/**
 * @file 見取り図の「確認と場の点検」のマス — 学年 1 年ぶんの時間軸に確認の印を置く。
 *
 * @what: 列の左端 = 4 月、右端 = 翌 3 月として、月で決まる確認を番号の印で置き、
 *   月を持たない場の点検は帯で出す。印に触れると時期と目安が出る。
 * @why: 「いつ測るか」は文で読むより時間軸の位置で分かる (代表 2026-08-23)。
 * @failure: 描画のみ。月の無い確認は印にならず帯にだけ入る。
 */

import type { CalibrationPoint, Stage } from "../model";
import { checkMark, isTimedCheck, schoolYearPosition, shortTiming } from "../model/milestones";
import "./study.css";

export function RoadmapStageTrack({
  stage,
  checkpoints,
}: {
  stage: Stage;
  checkpoints: CalibrationPoint[];
}) {
  const timed = checkpoints.filter(isTimedCheck);
  const untimed = checkpoints.filter((c) => !isTimedCheck(c));
  return (
    <div className="study-map-track" aria-label={`${stage.period}のチェックテストと体験のふり返り`}>
      <div className="study-map-track-line" aria-hidden="true" />
      {untimed.length > 0 ? (
        <div className="study-map-band" title={untimed.map((c) => c.criterion).join(" / ")}>
          {untimed.map((c) => c.label).join("・")}
          <span className="study-map-band-sub">年に 1 回</span>
        </div>
      ) : null}
      {timed.map((c) => {
        const pos = schoolYearPosition(c.month!);
        return (
          <div
            key={c.id}
            className={`study-map-mark${pos > 0.5 ? " study-map-mark--late" : ""}`}
            style={{ left: `clamp(0px, calc(${pos * 100}% - 22px), calc(100% - 44px))` }}
          >
            <span className="study-map-mark-dot" title={`${c.label} ${c.timing}: ${c.criterion}`}>
              {checkMark(c)}
            </span>
            <span className="study-map-mark-label">{shortTiming(c)}</span>
          </div>
        );
      })}
    </div>
  );
}
